import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({    
    warning: {
        float: 'right',
        width: '100px'
    }
}));

export default useStyles;